// extracted by mini-css-extract-plugin
export var boxItems = "_9h-1";
export var boxItemsLg = "_9h-2";
export var button = "_9h-7";
export var buttonHoverless = "_9h-9";
export var buttonLg = "_9h-8";
export var filterGroupBox = "_9h-0";
export var icon = "_9h-3";
export var iconSecondary = "_9h-6";
export var iconWrapper = "_9h-4";
export var iconWrapperLg = "_9h-5";
export var truncatedLabel = "_9h-a";